import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Body from "src/components/common/Body";
import Box from "src/components/common/Box";
import Button from "src/components/common/Button";
import SearchInput from "src/components/common/SearchInput";
import List from "src/components/common/List";
import SearchSortItem from "src/components/filter/SearchSortItem";
import BottomModal, { RefProps } from "src/components/common/BottomModal";
import SVG from "src/utils/SVG";
import styled from "styled-components";
import FulfillListItem from "src/components/notice/FulfillListItem";
import ComfirmItem from "src/components/notice/ComfirmItem";
import { useSelectGroupQuery, useSelectStoreQuery } from "../../api/userAPI";
import reuseQueryStringV2 from "../../utils/reuseQueryStringV2";
import SearchStoreFilterItemV2 from "../../components/filter/SearchStoreFilterItemV2";
import Chip from "../../components/common/Chip";
import GroupItemV2 from "../../components/manage/GroupItemV2";
import { useAppSelector } from "../../store/actions/action";
import { useDispatch } from "react-redux";
import { setNoticeRegister } from "../../store/reducers/noticeReduce";
import { useGetGroupStoreQuery } from "../../api/noticeAPI";
import BottomModalV2 from "../../components/common/BottomModalV2";

const initStore: StoreFilter[] = [
  { storeType: "백화점", checked: false },
  { storeType: "대리점", checked: false },
  { storeType: "직영점", checked: false },
  { storeType: "면세점", checked: false },
];
const initFilter: Filter = { sortSearchString: "최신순", newStoreSearchString: "", typeSearchArray: [], contentsSearchString: "" };

function fulfillSelectList() {
  const navigate = useNavigate();
  const [content, setContent] = useState("");
  const [sortFilter, setSortFilter] = useState<Filter>(initFilter);
  const [strSortFilter, setStrSortFilter] = useState(reuseQueryStringV2(sortFilter));
  const storeListAPI = useSelectStoreQuery(strSortFilter);
  const noticeData = useAppSelector((state) => state.noticeReduce);
  const [storeList, setStoreList] = useState<Store[]>([]);
  const [newStoreToggle, setNewStoreToggle] = useState<boolean>(false);
  const filterModalRef = React.useRef<RefProps>(null);
  const [storeFilterList, setStoreFilterList] = useState<StoreFilter[]>(initStore);
  const [applyStoreFilterList, setApplyStoreFilterList] = useState<StoreFilter[]>(initStore);
  //useInfo -> Group 목록 가져오기
  const userInfo = useAppSelector((state) => state.userReduce.userInfo);
  const groupAPI = useSelectGroupQuery({ userId: userInfo.user_id, type: "S" });
  const [selectedGroup, setSelectedGroup] = useState<Group>({ group_part_idx: 1, group_name: "", group_purpose: "" });
  //Group 검색 기능
  const [groupContent, setGroupContent] = useState("");
  const [sortGroupFilter, setSortGroupFilter] = useState<Filter>(initFilter);
  const [strGroupSortFilter, setStrGroupSortFilter] = useState(reuseQueryStringV2(sortGroupFilter));
  const groupStoreAPI = useGetGroupStoreQuery({
    groupId: selectedGroup.group_part_idx,
    queryString: strGroupSortFilter,
  });
  const dispatch = useDispatch();
  const filterListRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    dispatch(setNoticeRegister({ beforeStores: noticeData.stores }));
  }, []);

  useEffect(() => {
    filterListRef.current && filterListRef.current.scrollTo({ behavior: "smooth", left: filterListRef.current.scrollLeft + filterListRef.current.scrollWidth });
  }, [applyStoreFilterList]);

  const openFilterModal = useCallback(() => {
    if (filterModalRef.current) filterModalRef.current.modalOpen();
  }, []);

  useEffect(() => {
    setStrSortFilter(reuseQueryStringV2(sortFilter));
  }, [sortFilter]);
  useEffect(() => {
    setStrGroupSortFilter(reuseQueryStringV2(sortGroupFilter));
  }, [sortGroupFilter]);
  useEffect(() => {
    storeListAPI?.data?.data && setStoreList(storeListAPI.data.data);
  }, [storeListAPI]);

  useEffect(() => {
    const tempTypeSearchArray: string[] = [];
    applyStoreFilterList.forEach((value) => value.checked && tempTypeSearchArray.push(value.storeType));
    setSortFilter({ ...sortFilter, typeSearchArray: tempTypeSearchArray });
  }, [applyStoreFilterList]);
  // 정렬모달 관련
  const [sortIdx, setSordIdx] = useState<number>(0);
  const sortModalRef = React.useRef<RefProps>(null);

  const openSortModal = useCallback(() => {
    if (sortModalRef.current) sortModalRef.current.modalOpen();
  }, []);
  //React.MouseEventHandler<HTMLButtonElement>
  const sortBtn = (e: any) => {
    const sortName = e.target.textContent;
    sortName && setSortFilter({ ...sortFilter, sortSearchString: sortName });
    if (sortModalRef.current) sortModalRef.current.modalClose();
  };

  const childrenSortIdxFunc = (idx: number) => {
    setSordIdx(idx);
  };

  // 그룹모달 관련
  const groupModalRef = React.useRef<RefProps>(null);
  const confirmModalRef = React.useRef<RefProps>(null);
  const openGroupModal = useCallback(() => {
    setGroupContent("");
    setSortGroupFilter({ ...sortGroupFilter, contentsSearchString: "" });
    if (groupModalRef.current) {
      groupModalRef.current.modalOpen();
    }
  }, []);

  //그룹 채널 적용
  function onConfirm() {
    let storeData = noticeData.beforeStores ? [...noticeData.beforeStores] : [];
    const tempStoreData = noticeData.tempStores ? [...noticeData.tempStores] : [];
    const deleteTempStoreData = noticeData.deleteTempStore ? [...noticeData.deleteTempStore] : [];
    tempStoreData.forEach((tmpStore) => (storeData.includes(tmpStore) ? {} : storeData.push(tmpStore)));
    deleteTempStoreData.forEach((delStore) => (storeData.includes(delStore) ? (storeData = storeData.filter((res) => res !== delStore)) : {}));

    dispatch(setNoticeRegister({ beforeStores: storeData }));
    dispatch(setNoticeRegister({ tempStores: [] }));
    dispatch(setNoticeRegister({ deleteTempStore: [] }));
  }

  function closeConfirmModal() {
    dispatch(setNoticeRegister({ stores: noticeData.beforeStores }));
    if (confirmModalRef.current) confirmModalRef.current.modalClose();
    navigate(-1);
  }

  const newStoreBtn = () => {
    if (newStoreToggle) {
      setSortFilter({ ...sortFilter, newStoreSearchString: "" });
    } else {
      setSortFilter({ ...sortFilter, newStoreSearchString: "T" });
    }
    setNewStoreToggle(!newStoreToggle);
  };
  const [initVisible, setInitVisible] = useState<boolean>(false);
  const setInitFunc = (propsSelectedFliterCheck: boolean) => {
    setInitVisible(propsSelectedFliterCheck);
  };
  const closeBtn = () => {
    setStoreFilterList(applyStoreFilterList);
  };
  const confirmBtn = () => {
    setApplyStoreFilterList(storeFilterList);
    filterModalRef.current && filterModalRef.current.modalClose();
  };
  const resetButton = () => {
    setStoreFilterList(initStore);
  };

  function changeChecked(value: StoreFilter) {
    const temp: StoreFilter[] = storeFilterList.map((filter) =>
      filter.storeType === value.storeType ? { ...filter, checked: !filter.checked } : { ...filter, checked: filter.checked },
    );
    setStoreFilterList(temp);
  }

  function deleteFilter(value: StoreFilter) {
    const temp: StoreFilter[] = applyStoreFilterList.map((filter) => (filter.storeType === value.storeType ? { ...filter, checked: false } : filter));
    setApplyStoreFilterList(temp);
    setStoreFilterList(temp);
  }

  function searchContents(e: any) {
    const temp = e?.currentTarget.parentElement?.childNodes[0].value;
    setContent(temp);
    setSortFilter({ ...sortFilter, contentsSearchString: temp });
  }

  function searchGroupContents(e: any) {
    const temp = e?.currentTarget.parentElement?.childNodes[0].value;
    setGroupContent(temp);
    setSortGroupFilter({ ...sortGroupFilter, contentsSearchString: temp });
  }

  function onKeyPress(e: any) {
    e.key === "Enter" && searchContents(e);
  }

  function onKeyGorupPress(e: any) {
    e.key === "Enter" && searchGroupContents(e);
  }

  function deleteSearchContents() {
    setContent("");
    setSortFilter({ ...sortFilter, contentsSearchString: "" });
  }

  function deleteSearchGroupContents() {
    setGroupContent("");
    setSortGroupFilter({ ...sortFilter, contentsSearchString: "" });
  }
  //그룹 채널 선택
  function onClick(target: Group) {
    dispatch(setNoticeRegister({ tempStores: noticeData.beforeStores }));
    openGroupModal();
    setSelectedGroup(target);
  }
  //취소 및 뒤로가기
  function back() {
    if (noticeData.beforeStores && noticeData.stores && noticeData.beforeStores.toString() !== noticeData.stores.toString()) {
      if (window.confirm("선택한 이행매장을 저장하지 않고 나가시겠습니까?")) {
        navigate(-1);
      }
    } else {
      navigate(-1);
    }
  }

  function modalCloseAlert() {
    return window.confirm("선택한 이행매장을 저장하지 않고 나가시겠습니까?");
  }

  function groupChannalClose() {
    let alert = false;
    if (noticeData.tempStores && noticeData.beforeStores) {
      try {
        if (JSON.stringify(noticeData.tempStores) !== JSON.stringify(noticeData.beforeStores)) alert = true;
      } catch (e) {
        console.error(e);
      }
    }
    if (noticeData.deleteTempStore && noticeData.deleteTempStore.length > 0) alert = true;

    if (alert === false) return true;

    if (alert && modalCloseAlert()) {
      dispatch(setNoticeRegister({ tempStores: [] }));
      dispatch(setNoticeRegister({ deleteTempStore: [] }));
      return true;
    } else {
      return false;
    }
  }

  return (
    <>
      <header>
        <div>
          <Button variant="text" className="btn-back" onClick={() => back()}>
            이행매장
          </Button>
        </div>
        <div className="btn-box">
          <Button variant="text" onClick={() => confirmModalRef.current && confirmModalRef?.current.modalOpen()}>
            저장
          </Button>
        </div>
      </header>

      <Body type="detail">
        <Box pd="20px 15px">
          <SearchInput
            type="text"
            id="search-input"
            placeholder="검색어를 입력해주세요."
            defaultValue={content}
            onClick={(e) => searchContents(e)}
            onKeyPress={(e) => onKeyPress(e)}
            deleteSearchContentFunc={deleteSearchContents}
          />
        </Box>

        <GroupItemV2 group={groupAPI?.data as Group[]} onClick={onClick} />

        <FilterBtnSet ref={filterListRef}>
          <Button variant="contained" br="round" color="secondary" size="medium" onClick={openFilterModal}>
            <SVG name="filter" width={16} height={16} viewBox="0 0 16 16" />
            필터
          </Button>
          <Button variant="contained" br="round" color="secondary" size="medium" onClick={openSortModal}>
            <SVG name="sort" width={14.637} height={16.348} viewBox="0 0 14.637 16.348" />
            {sortFilter.sortSearchString}
          </Button>
          <Button className="only-new" variant="contained" br="round" color={newStoreToggle ? "active" : "secondary"} size="medium" onClick={newStoreBtn}>
            {newStoreToggle ? (
              <SVG name="toggleActive" width={16} height={16} viewBox="0 0 16 16" />
            ) : (
              <SVG name="toggle" width={16} height={16} viewBox="0 0 16 16" />
            )}
            신규매장만
          </Button>
          {applyStoreFilterList.map((value, index) => {
            return (
              value.checked && (
                <Chip variant="contained" deleted={true} key={index} onDelete={() => deleteFilter(value)}>
                  {value.storeType}
                </Chip>
              )
            );
          })}
        </FilterBtnSet>

        <FulfillListItem storeList={storeList} reduxName={"beforeStores"} />
      </Body>

      <BottomModal
        ref={filterModalRef}
        onClick={() => resetButton()}
        onClick2={() => confirmBtn()}
        onClick3={() => closeBtn()}
        modalTitle="검색 필터"
        headerBtn="초기화"
        footerBtn="적용"
        dimClickFun={closeBtn}
        initVisible={initVisible}
      >
        <List pd="0 15px" itemPd="20px 0">
          <SearchStoreFilterItemV2 title={"매장 유형"} filterList={storeFilterList} changeChecked={changeChecked} />
        </List>
      </BottomModal>

      <BottomModal modalTitle="정렬" ref={sortModalRef}>
        <List pd="0 15px">
          <SearchSortItem sortData={["최신순", "오래된순", "가나다순"]} onClick={(e) => sortBtn(e)} initIdx={sortIdx} parentSortIdxFunc={childrenSortIdxFunc} />
        </List>
      </BottomModal>

      <BottomModalV2 modalTitle={selectedGroup.group_name} footerBtn="적용" onConfirm={onConfirm} onClose={groupChannalClose} ref={groupModalRef}>
        <Box pd="20px 15px">
          <SearchInput
            type="text"
            id="search-input"
            placeholder="검색어를 입력해주세요."
            defaultValue={groupContent}
            onClick={(e) => searchGroupContents(e)}
            onKeyPress={(e) => onKeyGorupPress(e)}
            deleteSearchContentFunc={deleteSearchGroupContents}
          />
        </Box>
        <Box pd="0 15px">
          <Box pd="0">{groupStoreAPI?.data?.data && <FulfillListItem storeList={groupStoreAPI.data.data} reduxName={"tempStores"} />}</Box>
        </Box>
      </BottomModalV2>

      <BottomModal modalTitle="이행대상 확인" footerBtn="확인" onClick2={closeConfirmModal} ref={confirmModalRef}>
        <Box pd="0 15px">
          <ComfirmMes>
            선택한 대상은 총 <span>{noticeData.beforeStores && noticeData.beforeStores.length}</span>개입니다.
            <br />
            실수가 없는지 다시 한번 확인해주세요!
          </ComfirmMes>
        </Box>
        <List pd="0 15px" itemPd="14px 0">
          <ComfirmItem />
        </List>
      </BottomModal>
    </>
  );
}

const FilterBtnSet = styled.div`
  overflow: hidden;
  overflow-x: scroll;
  width: 100%;
  padding: 15px;
  border-bottom: 1px solid ${({ theme }) => theme.color.linePrimary};
  ${({ theme }) => theme.flexBox.flexMixin("row", "flex-start")}
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
  }
  > * {
    flex: 0 0 auto;
    margin-right: 10px;
    &:last-child {
      margin-right: 0;
    }
  }
  > button {
    > svg {
      position: relative;
      top: -1px;
    }
  }
  .only-new {
    > svg {
      top: 2px;
      left: 2px;
    }
  }
`;

const ComfirmMes = styled.p`
  padding: 16px 0 24px;
  margin-bottom: 8px;
  border-bottom: 1px solid ${({ theme }) => theme.color.linePrimary};
  text-align: center;
  line-height: 20px;
  > span {
    font-family: "Poppins";
    font-size: 24px;
    color: ${({ theme }) => theme.color.main};
  }
`;

export default fulfillSelectList;
